import { Component, Input, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ContextMenu } from 'primeng/contextmenu';
import { MenuItem } from "primeng/api";

@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {

    @ViewChild(ContextMenu, {static: true}) contextMenu: ContextMenu;

    @Input() contextMenuItems: MenuItem[];

    constructor() {
    }

    show(event) {
        this.contextMenu.show(event);
    }

    close() {
        this.contextMenu.hide();
    }

    ngOnInit() {
    }
}
